export function keys<T extends Record<string | symbol | number, unknown>>(
  obj: T,
): (keyof T)[] {
  return Object.keys(obj)
    .map((key) => key in obj && key)
    .filter(Boolean);
}
